module.exports = __webpack_public_path__ + "static/img/s156.a27bcbc1.png";